import React, { useState, useMemo } from "react";
import AboutHeader from "../../components/aboutHeader/aboutHeader";
import Footer from "../../components/footer/footer";
import PaymentAccepted from "../../components/paymentAccepted/paymentAccepted";
import countryList from "react-select-country-list";
import Select from "react-select";
import Alert from "../../components/alert/alert";
import "./register.css";
import firebase from "firebase";
import { auth, firestore } from "../../db/config";
export default function Register() {
  const [value, setValue] = useState("");
  const options = useMemo(() => countryList().getData(), []);
  const [alertMessage, setalertMessage] = useState({
    message: "",
    status: "",
    loader: false,
  });
  const changeHandler = (value) => {
    setValue(value);
  };

  const [RegisterValues, setRegisterValues] = useState({
    referralName: "",
    firstName: "",
    lastName: "",
    userName: "",
    password: "",
    confirmPassword: "",
    transactionPin: "",
    confirmTransactionPin: "",
    emailAddress: "",
    mobileNumber:""
  });
  const handleChange = (value, attr) => {
    setRegisterValues({
      ...RegisterValues,
      [attr]: value,
    });
  };
  const [termsValue, settermsValue] = useState(false);
  const handleTerms = (value) => {
    settermsValue(value);
  };
  const [searchRefState, setsearchRefState] = useState({
    refSearchState: "",
  });
  const handleSubmit = () => {
    setalertMessage({ loader: true });
    if (
      value.label === "" ||
      value.label === undefined ||
      RegisterValues.firstName === "" ||
      RegisterValues.lastName === "" ||
      RegisterValues.userName === "" ||
      RegisterValues.password === "" ||
      RegisterValues.confirmPassword === "" ||
      RegisterValues.transactionPin === "" ||
      RegisterValues.confirmTransactionPin === "" ||
      RegisterValues.emailAddress === ""
    ) {
      setalertMessage({
        status: "danger",
        message: "Please fill out all empty fields.",
        loader: false,
      });
      setRegisterValues({
        referralName: "",
        firstName: "",
        lastName: "",
        userName: "",
        password: "",
        confirmPassword: "",
        transactionPin: "",
        confirmTransactionPin: "",
        emailAddress: "",
        mobileNumber:""
      });
      setValue("");
      settermsValue(false);
    } else if (RegisterValues.password.length < 6) {
      setalertMessage({
        status: "danger",
        message: "Your password must be atleast 6 characters.",
        loader: false,
      });
      setRegisterValues({
        referralName: "",
        firstName: "",
        lastName: "",
        userName: "",
        password: "",
        confirmPassword: "",
        transactionPin: "",
        confirmTransactionPin: "",
        emailAddress: "",
        mobileNumber:""
      });
      setValue("");
      settermsValue(false);
    } else if (RegisterValues.password !== RegisterValues.confirmPassword) {
      setalertMessage({
        status: "danger",
        message: "The password you enter does not match.",
        loader: false,
      });
      setRegisterValues({
        referralName: "",
        firstName: "",
        lastName: "",
        userName: "",
        password: "",
        confirmPassword: "",
        transactionPin: "",
        confirmTransactionPin: "",
        emailAddress: "",
        mobileNumber:""
      });
      setValue("");
      settermsValue(false);
    } else if (
      RegisterValues.transactionPin !== RegisterValues.confirmTransactionPin
    ) {
      setalertMessage({
        status: "danger",
        message: "The transaction pin yo enter does not match.",
        loader: false,
      });
      setRegisterValues({
        referralName: "",
        firstName: "",
        lastName: "",
        userName: "",
        password: "",
        confirmPassword: "",
        transactionPin: "",
        confirmTransactionPin: "",
        emailAddress: "",
        mobileNumber:""
      });
      setValue("");
      settermsValue(false);
    } else if (!termsValue) {
      setalertMessage({
        status: "danger",
        message: "You must agree to the terms and conditions.",
        loader: false,
      });
      setRegisterValues({
        referralName: "",
        firstName: "",
        lastName: "",
        userName: "",
        password: "",
        confirmPassword: "",
        transactionPin: "",
        confirmTransactionPin: "",
        emailAddress: "",
        mobileNumber:""
      });
      setValue("");
      settermsValue(false);
    } else {
      auth
        .createUserWithEmailAndPassword(
          RegisterValues.emailAddress,
          RegisterValues.password
        )
        .then((data) => {
          const {
            referralName,
            firstName,
            lastName,
            emailAddress,
            password,
            transactionPin,
            userName,
            mobileNumber
          } = RegisterValues;
          firestore
            .collection("users")
            .doc(data.user.uid)
            .set({
              referralName,
              firstName,
              emailAddress,
              password,
              transactionPin,
              userName,
              lastName,
              country: value.label,
              createdAt: firebase.database.ServerValue.TIMESTAMP,
              mobileNumber
            })
            .then((data) => {
              if (
                RegisterValues.referralName === "" ||
                searchRefState.refSearchState === "Searching for user..."
              ) {
                window.location.href = "/my_account";
                setalertMessage({
                  message: "Registration successful.",
                  status: "success",
                  loader: false,
                });
                setRegisterValues({
                  referralName: "",
                  firstName: "",
                  lastName: "",
                  userName: "",
                  password: "",
                  confirmPassword: "",
                  transactionPin: "",
                  confirmTransactionPin: "",
                  emailAddress: "",
                  mobileNumber:""
                });
                setValue("");
                settermsValue(false);
              } else {
                firestore
                  .collection("users")
                  .where("emailAddress", "==", RegisterValues.referralName)
                  .get()
                  .then((data) => {
                    data.docs.map((data) => {
                      firestore
                        .collection("referrals")
                        .add({
                          FirstName: RegisterValues.firstName,
                          lastName: RegisterValues.lastName,
                          rferralEmail: RegisterValues.referralName,
                          emailAddress: RegisterValues.emailAddress,
                          createdAt: firebase.database.ServerValue.TIMESTAMP,
                          comission: 200,
                        })
                        .then(() => {
                          firestore
                            .collection("userPaymentDetails")
                            .where(
                              "emailAddress",
                              "==",
                              RegisterValues.referralName
                            )
                            .get()
                            .then((data) => {
                              data.docs.map((data) => {
                                const getPayPalBalance =
                                  data.data().payPalBalance + 200;
                                firestore
                                  .collection("userPaymentDetails")
                                  .doc(data.id)
                                  .update({
                                    payPalBalance: getPayPalBalance,
                                  })
                                  .then(() => {
                                    window.location.href = "/my_account";
                                    setalertMessage({
                                      message: "Registration successful.",
                                      status: "success",
                                      loader: false,
                                    });
                                    setRegisterValues({
                                      referralName: "",
                                      firstName: "",
                                      lastName: "",
                                      userName: "",
                                      password: "",
                                      confirmPassword: "",
                                      transactionPin: "",
                                      confirmTransactionPin: "",
                                      emailAddress: "",
                                      mobileNumber:""
                                    });
                                    setValue("");
                                    settermsValue(false);
                                  })
                                  .catch((error) => {
                                    setalertMessage({
                                      message: error.message,
                                      status: "danger",
                                      loader: false,
                                    });
                                    setRegisterValues({
                                      referralName: "",
                                      firstName: "",
                                      lastName: "",
                                      userName: "",
                                      password: "",
                                      confirmPassword: "",
                                      transactionPin: "",
                                      confirmTransactionPin: "",
                                      emailAddress: "",
                                      mobileNumber:""
                                    });
                                    setValue("");
                                    settermsValue(false);
                                  });
                              });
                            })
                            .catch((error) => {
                              setalertMessage({
                                message: error.message,
                                status: "danger",
                                loader: false,
                              });
                              setRegisterValues({
                                referralName: "",
                                firstName: "",
                                lastName: "",
                                userName: "",
                                password: "",
                                confirmPassword: "",
                                transactionPin: "",
                                confirmTransactionPin: "",
                                emailAddress: "",
                                mobileNumber:""
                              });
                              setValue("");
                              settermsValue(false);
                            });
                        })
                        .catch((error) => {
                          setalertMessage({
                            message: error.message,
                            status: "danger",
                            loader: false,
                          });
                          setRegisterValues({
                            referralName: "",
                            firstName: "",
                            lastName: "",
                            userName: "",
                            password: "",
                            confirmPassword: "",
                            transactionPin: "",
                            confirmTransactionPin: "",
                            emailAddress: "",
                            mobileNumber:""
                          });
                          setValue("");
                          settermsValue(false);
                        });
                    });
                  });
              }
            })
            .catch((error) => {
              setalertMessage({
                message: error.message,
                status: "danger",
                loader: false,
              });
              setRegisterValues({
                referralName: "",
                firstName: "",
                lastName: "",
                userName: "",
                password: "",
                confirmPassword: "",
                transactionPin: "",
                confirmTransactionPin: "",
                emailAddress: "",
                mobileNumber:""
              });
              setValue("");
              settermsValue(false);
            });
        })
        .catch((error) => {
          setalertMessage({
            message: error.message,
            status: "danger",
            loader: false,
          });
          setRegisterValues({
            referralName: "",
            firstName: "",
            lastName: "",
            userName: "",
            password: "",
            confirmPassword: "",
            transactionPin: "",
            confirmTransactionPin: "",
            emailAddress: "",
            mobileNumber:""
          });
          setValue("");
          settermsValue(false);
        });
    }
  };

  const handleSearchReferral = (value, attr) => {
    setsearchRefState({
      refSearchState: "Searching for user...",
    });
    setRegisterValues({
      ...RegisterValues,
      referralName: value,
    });

    firestore
      .collection("users")
      .where("emailAddress", "==", value)
      .onSnapshot((user) => {
        user.docs.map((data) => {
          if (data.exists) {
            setsearchRefState({
              refSearchState: "Email address match.",
            });
            setRegisterValues({
              ...RegisterValues,
              referralName: value,
            });
          } else {
            setsearchRefState({
              refSearchState: "Email address does not match.",
            });
            setRegisterValues({
              ...RegisterValues,
              referralName: "",
            });
          }
        });
      });
  };
  return (
    <div>
      <AboutHeader />
      <div class="page_title_section">
        <div class="page_header">
          <div class="container">
            <div class="row">
              <div class="col-lg-9 col-md-9 col-12 col-sm-8">
                <h1>Register</h1>
              </div>
              <div class="col-lg-3 col-md-3 col-12 col-sm-4">
                <div class="sub_title_section">
                  <ul class="sub_title">
                    <li>
                      {" "}
                      <a href="/"> Home </a>&nbsp; / &nbsp;{" "}
                    </li>
                    <li>Register</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="login_wrapper fixed_portion float_left">
        <div class="container">
          <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12">
              <div class="login_top_box float_left">
                <div class="login_banner_wrapper">
                  {/* <img src="images/logo2.png" alt="logo" /> */}
                  <div style={{ marginBottom: "150px", color: "white" }}>
                    Treasure Growth Investment
                  </div>
                  <div class="about_btn google_wrap float_left">
                    {/* <a href="#">
                      login With Google <i class="fab fa-google"></i>
                    </a> */}
                  </div>
                  <div class="jp_regis_center_tag_wrapper jb_register_red_or">
                    <h1>OR</h1>
                  </div>
                </div>
                <div class="login_form_wrapper">
                  <div class="sv_heading_wraper heading_wrapper_dark dark_heading hwd">
                    <h3> Register to enter</h3>
                  </div>
                  <div class="row">
                    <div class="form-group icon_form comments_form ">
                      <input
                        type="email"
                        class="form-control require"
                        placeholder="Refarral Email Address(optional)"
                        value={RegisterValues.referralName}
                        onChange={(evt) =>
                          handleSearchReferral(evt.target.value, "referralName")
                        }
                      />
                      {RegisterValues.referralName ? (
                        <span>
                          {searchRefState.refSearchState ===
                            "Searching for user..." ||
                          searchRefState.refSearchState ===
                            "Email address does not match." ? (
                            ""
                          ) : (
                            <span style={{ color: "green" }}>
                              {searchRefState.refSearchState}
                            </span>
                          )}
                        </span>
                      ) : (
                        ""
                      )}
                    </div>
                    <div class="form-group icon_form comments_form ">
                      <input
                        type="text"
                        class="form-control require"
                        placeholder="First Name*"
                        value={RegisterValues.firstName}
                        onChange={(evt) =>
                          handleChange(evt.target.value, "firstName")
                        }
                      />
                    </div>
                    <div class="form-group icon_form comments_form ">
                      <input
                        type="text"
                        class="form-control require"
                        placeholder="Last Name*"
                        value={RegisterValues.lastName}
                        onChange={(evt) =>
                          handleChange(evt.target.value, "lastName")
                        }
                      />
                    </div>
                    <div class="form-group icon_form comments_form ">
                      <input
                        type="text"
                        class="form-control require"
                        placeholder="Username*"
                        value={RegisterValues.userName}
                        onChange={(evt) =>
                          handleChange(evt.target.value, "userName")
                        }
                      />
                    </div>

                    <div class="form-group icon_form comments_form ">
                      <input
                        type="password"
                        class="form-control require"
                        placeholder="Password *"
                        value={RegisterValues.password}
                        onChange={(evt) =>
                          handleChange(evt.target.value, "password")
                        }
                      />
                    </div>
                    <div class="form-group icon_form comments_form ">
                      <input
                        type="password"
                        class="form-control require"
                        placeholder="Confirm Password*"
                        value={RegisterValues.confirmPassword}
                        onChange={(evt) =>
                          handleChange(evt.target.value, "confirmPassword")
                        }
                      />
                    </div>
                    <div class="form-group icon_form comments_form ">
                     <div style={{display:"flex",justifyContent:"flex-start"}}> <label>Select country</label></div>
                      <Select
                        options={options}
                        value={value}
                        onChange={changeHandler}
                      />
                      {/* <select
                        class="form-select form-select-lg mb-3"
                        aria-label=".form-select-lg example"
                      >
                        <option selected>Country</option>
                        <option value="1">One</option>
                        <option value="2">Two</option>
                        <option value="3">Three</option>
                      </select> */}
                    </div>
                    <div class="form-group icon_form comments_form ">
                      <input
                        type="text"
                        class="form-control require"
                        placeholder="Mobile Number"
                        value={RegisterValues.mobileNumber}
                        onChange={(evt) =>
                          handleChange(evt.target.value, "mobileNumber")
                        }
                      />
                    </div>
                    <div class="form-group icon_form comments_form ">
                      <input
                        type="password"
                        class="form-control require"
                        placeholder="Transaction Pin*"
                        value={RegisterValues.transactionPin}
                        onChange={(evt) =>
                          handleChange(evt.target.value, "transactionPin")
                        }
                      />
                    </div>
                    <div class="form-group icon_form comments_form ">
                      <input
                        type="password"
                        class="form-control require"
                        placeholder="Confirm Transaction Pin*"
                        value={RegisterValues.confirmTransactionPin}
                        onChange={(evt) =>
                          handleChange(
                            evt.target.value,
                            "confirmTransactionPin"
                          )
                        }
                      />
                    </div>
                    <div class="form-group icon_form comments_form ">
                      <input
                        type="email"
                        class="form-control require"
                        placeholder="Email Address*"
                        value={""}
                        value={RegisterValues.emailAddress}
                        onChange={(evt) =>
                          handleChange(evt.target.value, "emailAddress")
                        }
                      />
                    </div>
                   
                  </div>

                  <div class="login_remember_box">
                    <label class="control control--checkbox">
                      <input
                        type="checkbox"
                        onChange={(evt) => handleTerms(evt.target.checked)}
                        value={termsValue}
                        checked={termsValue}
                      />
                      <span class="control__indicator"></span>I agreed to the
                      Terms and Conditions.
                    </label>
                  </div>
                  {alertMessage.message ? (
                    <Alert details={{ ...alertMessage }} />
                  ) : (
                    ""
                  )}
                  {alertMessage.loader ? (
                    <div class="about_btn login_btn float_left">
                      <a className="register__button">Please wait...</a>
                    </div>
                  ) : (
                    <div
                      class="about_btn login_btn float_left"
                      onClick={handleSubmit}
                    >
                      <a className="register__button">Submit</a>
                    </div>
                  )}

                  {/* <div class="dont_have_account float_left">
                    <p>
                      Don’t have an acount ? <a href="register.html">Sign up</a>
                    </p>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <PaymentAccepted />
      <Footer />
    </div>
  );
}
